import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/item-option';

import { AdvancedSearchOrderContext } from '../../context';
import messages from './messages';

const ItemOptionFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.itemOption} updateFilter={updateFilter} />;
};

export default ItemOptionFilter;
